/*
  Powrot na strone po logowaniu. Google wraca zawsze na glowna (redirectTo = origin, bo tylko
  ten adres jest pewny na liscie dozwolonych w Supabase), a link potwierdzajacy rejestracje
  otwiera nowa karte — dlatego sciezka czeka w localStorage, a odbiera ja strona glowna.
*/
const STORAGE_KEY = 'superlekcja.return-after-login'
// Dluzej nie czekamy: porzucone logowanie nie moze po tygodniu przekierowac kogos z glownej.
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export function rememberReturnPath(path: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ path, savedAt: Date.now() }))
  } catch {
    // Bez storage uzytkownik po prostu zostaje na glownej.
  }
}

/** Zwraca zapamietana sciezke (jesli swieza) i ja usuwa — kazda sciezka dziala raz. */
export function takeReturnPath(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    localStorage.removeItem(STORAGE_KEY)
    const { path, savedAt } = JSON.parse(raw) as { path: string; savedAt: number }
    return Date.now() - savedAt <= MAX_AGE_MS ? path : null
  } catch {
    return null
  }
}
